import React, { useEffect } from 'react';
import routes from 'app/routes';

import { useContext as useUsersContext } from 'components/Users/Context';

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

import PropTypes from 'prop-types';
import ViewList from './Views/List/Index';
import ChooseTopics from './Views/New/ChooseTopics';
import OrderTopics from './Views/New/OrderTopics';
import Summary from './Views/New/Summary';

import EditChooseTopics from './Views/Edit/ChooseTopics';
import EditOrderTopics from './Views/Edit/OrderTopics';
import EditSummary from './Views/Edit/Summary';

export default function Main({ enterpriseId }) {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.managers.templates.index,
      element: <ViewList />,
    },
    {
      path: routes.managers.templates.new,
      element: <Navigate to={routes.managers.templates.chooseTopics} replace />,
    },
    {
      path: routes.managers.templates.chooseTopics,
      element: <ChooseTopics enterpriseId={enterpriseId} />,
    },
    {
      path: routes.managers.templates.orderTopics,
      element: <OrderTopics enterpriseId={enterpriseId} />,
    },
    {
      path: routes.managers.templates.summary,
      element: <Summary />,
    },
    {
      path: routes.managers.templates.editChooseTopics(),
      element: <EditChooseTopics enterpriseId={enterpriseId} />,
    },
    {
      path: routes.managers.templates.editOrderTopics(),
      element: <EditOrderTopics enterpriseId={enterpriseId} />,
    },
    {
      path: routes.managers.templates.editSummary(),
      element: <EditSummary />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

Main.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
